import FadeIn from 'react-fade-in';
import image1 from './images/4.jpg';
import image2 from './images/5.jpg';

export const MainView = ({setView, setGalleryIndex}) => {


    function clickImage(index) {
        setView("gallery");
        setGalleryIndex(index);
    }

    return (
        <FadeIn>
            <br />
            <div className={"pagecontainer"} >
                <h1>Interactive Dynamic Volume Illumination with Refraction and Caustics</h1>

                <div className={"row"}>
                    <div className={"col s8"}>
                        This project is an implementation of the paper "<a href="https://ieeexplore.ieee.org/document/8017622" target="_blank"  rel="noreferrer">Interactive Dynamic Volume Illumination with
                        Refraction and Caustics</a>" by Jens G. Magnus and Stefan Bruckner.

                        The rendering technique proposed is a ray casting technique, however, contrary to the traditional approach of
                        casting straight rays through the volume using a precomputed lighting data structure it is extended
                        to support bent rays and the calculation of light transport in near-real time. In comparison to
                        the traditional equation for volume rendering, the proposed technique also features additional transfer
                        functions which are used to map values sampled from a scalar field not only to particle color
                        and opacity/extinction coefficients but also to medium color and the index of refraction at a
                        particular point in the volume. This expansion in dimensionality of the parameters which still
                        is naturally perceivable by humans is a new way to make complex volumetric data efficiently explorable and perceivable to the human brain.

                        <h1>Implementation</h1>
                        This project was implemented using C++ 17 and the DX12 Graphics API and is therefore only available on 64-bit Windows 10.
                        As opposed to the paper which uses fragment shaders for the computationally heavy parts we
                        implemented the light and viewing ray propagation in compute shaders.

                        <br/><br/>

                        Used libraries:

                        <ul>
                            <li className="datasetsli"><a href="https://github.com/ocornut/imgui" target="_blank"  rel="noreferrer">dear imgui</a></li>
                        </ul>

                    </div>
                    <div className={"col s4"}>
                        <img className={"fitimage"} src={image1} alt={"Volume Visualization"} onClick={() => clickImage(0)}/>
                        <img className={"fitimage"} src={image2} alt={"Another Volume Visualization"} onClick={() => clickImage(1)}/>
                    </div>
                </div>


                <div className={"row"}>

                </div>
        </div>
        </FadeIn>
    )
}
